import { render } from "./StripeVerifyPage.vue?vue&type=template&id=3177b974&scoped=true"
import script from "./StripeVerifyPage.vue?vue&type=script&lang=js"
export * from "./StripeVerifyPage.vue?vue&type=script&lang=js"

import "./StripeVerifyPage.vue?vue&type=style&index=0&id=3177b974&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3177b974"]])

export default __exports__